import styled from '@benzinga/themetron';
import React from 'react';
interface HeaderProps {
  title: string;
  subtitle?: string;
  resetOnClick?: () => void;
}

export const Header: React.FC<HeaderProps> = props => {
  return (
    <Wrapper>
      <Content>
        <Title>{props.title}</Title>
        {props.subtitle && <Subtitle>{props.subtitle}</Subtitle>}
      </Content>
      {props.resetOnClick && <ResetBtn onClick={props.resetOnClick}>Reset To Default</ResetBtn>}
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  background: ${({ theme }) => theme.colors.background};
  border-bottom: 1px solid ${({ theme }) => theme.colors.backgroundInactive};
  flex-shrink: 0;
  flex-direction: row;
  padding: 1.5em 0em;
  position: relative;
`;

const Content = styled.div`
  flex-grow: 1;
  gap: 0.5em;
`;

const Title = styled.div`
  color: ${({ theme }) => theme.colors.foregroundActive};
  font-family: 'Nimbus Sans D OT', Helvetica;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  letter-spacing: 0px;
  line-height: 32px;
  margin-top: -1px;
  margin-bottom: 0.25em;
  position: relative;
  white-space: nowrap;
  width: fit-content;
`;

const Subtitle = styled.div`
  color: ${({ theme }) => theme.colors.foregroundInactive};
  font-family: 'Nimbus Sans L', Helvetica;
  font-size: 14px;
  font-style: normal;
  font-weight: 300;
  letter-spacing: 0px;
  line-height: 20px;
  position: relative;
  white-space: nowrap;
`;

const ResetBtn = styled.button`
  display: inline-block;
  position: absolute;
  align-items: center;
  border: 1px solid;
  border-color: ${props => props.theme.colors.border};
  border-radius: 4px;
  justify-content: center;
  padding: 12px 24px;
  color: ${props => props.theme.colors.foregroundActive};
  font-weight: 700;
  letter-spacing: 0px;
  line-height: 20px;
  position: relative;
  white-space: nowrap;
  width: fit-content;
  height: fit-content;
`;
